import ProfileList from "./ProfileList";
import ProfileEdit from "./ProfileEdit";
import ProfileShow from "./ProfileShow";

const Profiles = { list: ProfileList, edit: ProfileEdit, show: ProfileShow };

export default Profiles;
